/**
 * @file Wrapper module in AngularJS for routing to overview page
 * @author Max van Loosbroek
 */

import './overview/OrderOverview/OrderOverview.module'
import StoreService from '../../common/redux/store.service'
import orderOverviewPage from './orderOverviewPage.component'

export default angular
  .module('components.orderOverviewPage', ['components.tb.orderOverviewReact'])
  .component('orderOverviewPage', orderOverviewPage)
  .service('StoreService', StoreService)
  .config(($stateProvider, $urlServiceProvider)=> {
    $urlServiceProvider.config.strictMode(false);
    $stateProvider.state('orders', {
      parent: 'app',
      url: `^/orders/?
        action&
        searchType&
        searchValue&
        sort&
        sort_order&
        token`,
      component: 'orderOverviewPage',
      reloadOnSearch: false,
      params: {},
      resolve: {}
    })
  }).name
